import usePushNotifications from '@/hooks/usePushNotifications';
import useNativeLinkInbox from '@/hooks/useNativeLinkInbox';

export default function PushNotificationsHost() {
  usePushNotifications();
  useNativeLinkInbox();
  return null;
}
